// extracted by mini-css-extract-plugin
module.exports = {"sortFilterContainer":"_64e85fd","section":"_aaa397c","checked":"_09c33e4","icon":"_5954fcf","sortBy":"_a4b53ba","arrow":"_03bd43a","upwardsArrow":"_11c1669"};